import { BOOK_AUTHOR } from "../../utils/constants";
import { get, post, put } from "../../utils/axios-config";
import { BookAuthorType } from "../../types/Library";
import { PagedRequestType, PagedResultsType } from "../../types/PagedResults";

export const createBookAuthor = async (data: BookAuthorType) => await post(BOOK_AUTHOR, data);

export const updateBookAuthor = async (data: BookAuthorType) => await put(BOOK_AUTHOR, data);

export const getBookAuthors = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || "1",
        PageSize: data?.PageSize?.toString() || "100",
        ...(data?.IdBook ? { IdBook: data.IdBook  } : {}),
        ...(data?.IdAuthor ? { IdAuthor: data.IdAuthor  } : {}),
    });
    const url = `${BOOK_AUTHOR}?${queryParams.toString()}`;
    return await get<PagedResultsType<BookAuthorType>>(url);
};
